import FlipCardDisplay from './FlipCardDisplay_v2';

export default FlipCardDisplay;
